import { StateViewModel } from '../../../models/viewModels/StateViewModel';
import './UpdateVersionModal.scss';
export class UpdateVersionModal {
    static $inject = ['close', 'confirm', 'agentBlocksThatNeedUpdate', 'StudioVersionService'];
    constructor(close, confirm, agentBlocksThatNeedUpdate, StudioVersionService) {
        this.StudioVersionService = StudioVersionService;
        this.close = close;
        this.confirm = confirm;
        this.agentBlocksThatNeedUpdate = agentBlocksThatNeedUpdate;
        this.agentBlockByVersion = this.groupBlocksByVersion();
    }
    _confirm(blocks) {
        this.confirm(blocks);
        this.close(true);
    }
    _cancel() {
        this.close(false);
    }
    groupBlocksByVersion() {
        const grouped = [];
        this.agentBlocksThatNeedUpdate.forEach(block => {
            const version = StateViewModel.getAiBlockVersion(block);
            const existingGroup = grouped.find(g => g.version === version);
            if (existingGroup) {
                existingGroup.blocks.push(block);
            }
            else {
                grouped.push({ version, blocks: [block] });
            }
        });
        return grouped;
    }
}
